import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import {Link} from 'react-router';
import Helmet from 'react-helmet';
import Spinner from '../../components/svg/spinner';
import { jobsRoute } from '../../routes/index';
import css from './job.scss';
import { formatNumber, DateFormatter } from '../../utils/date';
import Pixeltext from '../../components/svg/pixeltext';
import Image from '../../components/image/image';
import Share from '../../components/share/share';
import metaDesc from '../../utils/meta';
import translate from '../../utils/translate';

import ContextualMenu from '../../components/contextual/contextual';

import connect from '../../utils/connect';

import { fetchJob } from '../../actions/jobs';


//import css from './editorial.scss';

class JobPage extends Component {

	constructor(props) {
		super();

		this.metaDesc = '';
		this.state = {
			loading: Date.now(),
		};
	}

	componentWillMount() {
		//console.log('editorial will mount');
		this.fetchJob = bindActionCreators(fetchJob, this.props.dispatch);

		let preview = false;
		if (this.props.router.location && this.props.router.location.query && this.props.router.location.query.preview) {
			preview = this.props.router.location.query.preview
		}

		if (
			this.props.routeParams.slug &&
			this.props.routeParams.slug !== this.props.jobs.single.slug
		) {
			this.fetchJob(this.props.routeParams.slug, preview);
			if (!this.state.loading) {
				this.setState({
					loading: Date.now(),
				});
			}
		}
	}

	componentWillReceiveProps(nextProps) {
		const newState = {};
		if (nextProps.routeParams.slug !== this.props.routeParams.slug || this.props.items && nextProps.items.length !== this.props.items.length) {
			this.fetchJob(nextProps.routeParams.slug);
			if (!this.state.loading) {
				newState.loading = Date.now();
			}
		}

		if (
			this.state.loading &&
			nextProps.routeParams.slug === nextProps.jobs.single.slug
		) {
			newState.loading = false;
		}

		(Object.keys(newState).length) && (
			setTimeout(
				() => {
					this.setState(newState);
				},
				((Date.now() - this.state.loading) < 500) ? (500 - (Date.now() - this.state.loading)) : 0
			)
		);
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextProps.browser.window.width !== this.props.browser.window.width ||
			nextProps.jobs.single.id !== this.props.jobs.single.id ||
			nextProps.routeParams.slug !== this.props.routeParams.slug ||
			nextProps.jobs.items.length !== this.props.jobs.items.length ||
			nextState.loading !== this.state.loading ||
			nextState !== this.state
		);
	}

	render() {
		let job = this.props.jobs.single;
		let jobs = this.props.jobs.items;
		let date = new DateFormatter(job.createdDate);

		if (job.meta && job.meta.description !== this.metaDesc) {
			metaDesc(job.meta.description);
			this.metaDesc = job.meta.description;
		}

		let transitionClass = 'page__transition';

		if (this.state.loading) {
			transitionClass += ' page__transition--transitioning';
		}

		return (
			<div>
			{job.id && (
					<article className='job span14 margin-bottom-contextual'>
						<Helmet title={job.title + ' - Jobs - The FWA'}	 />

						<div className={transitionClass}>
							<header className='job__top'>
								<div className='job__top__share'>
									<Share title={job.title} url={window.location.href} browser={this.props.browser} />
								</div>
								<div className='span2 job__top__date pixel-pattern span14-mobile'>
									<Pixeltext x='0' text={date.date} className='job__top__date__day'/>
									<span className='job__top__date__month'>{date.month + ', ' + date.year}</span>
									<span className='job__top__date__text'>Job added — </span>
								</div>
								<div className='span12 job__top__right  span14-mobile'>
									<h1 className='job__top__title'>{job.title}</h1>
									<h2 className='job__top__subtitle'>{job.profiles.name}</h2>
								</div>
							</header>
							<div className='job__fill span2 hide-mobile'></div>
							<section className='job__content span8 span14-mobile'>
								<h2 className='span5 span11-mobile span7-tablet job__content__headline'>Job description</h2>
								<div className='span5 span11-mobile span7-tablet job__content__text' dangerouslySetInnerHTML={{__html: job.description}}></div>
								<h2 className='span5 span11-mobile span7-tablet job__content__headline'>How to apply</h2>
								<div className='span5 span11-mobile span7-tablet job__content__text' dangerouslySetInnerHTML={{__html: job.howTo}}></div>
								<div className='span8 hide-mobile job__content__splitter pixel-pattern'></div>
								<div className='span8 hide-mobile job__content__terms'>{translate('jobs/jobsCopyright')}</div>
							</section>
							<aside className='job__aside span4 span14-mobile'>
								{!!(job.profiles && job.profiles.logoProfile && job.profiles.logoProfile.normal) && (
									<div className='job__aside__top'>
										<Image className='profile__meta__image' {...job.profiles.logoProfile.normal} img={job.profiles.logoProfile.normal.src} span='' alt={job.profiles.name} />
									</div>
								)}

								<section className='job__aside__website'>
									<h2 className='job__aside__website__name'>{job.profiles.name}</h2>
									<a className='job__aside__website__url' href={job.profiles.website}>{job.profiles.website}</a>
								</section>
								<div className='job__aside__splitter pixel-pattern'></div>
								<section className='job__aside__location'>
									<h2 className='job__aside__location__title'>job location</h2>
									<span className='job__aside__location__name'>{job.city}</span>
									<span className='job__aside__location__street'>{job.address}</span>
									<span className='job__aside__location__city'>{job.zip + ' ' + job.city}</span>
									<span className='job__aside__location__country'>{job.country}</span>
								</section>
							</aside>
							<div className='hide-desktop hide-tablet clear-mobile job__aside__splitter pixel-pattern'></div>
							<div className='hide-desktop hide-tablet span14-mobile job__content__terms'>{translate('jobs/jobsCopyright')}</div>
						</div>

						<div className='cf'></div>
						<ContextualMenu jobId={job.id} enableJobs={true} />
					</article>
				) || (
				<Spinner className='case-single__spinner' size='80px'></Spinner>
				)
			}
			</div>
		);
	}

}

export default connect(JobPage);



/** WEBPACK FOOTER **
 ** ./frontend/containers/job/job.js
 **/